import { GetSurvivalHorizonServiceDataOutput } from '@liquitics/transaction';
import { SurvivalHorizonService } from './../survival-horizon.service';
import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-loro-ladder',
    templateUrl: './loro-ladder.component.html',
    styleUrls: ['./loro-ladder.component.css']
})
export class LoroLadderComponent implements OnInit, OnDestroy {
    tableData: any[] = [];
    showTable = false;
    subscription: Subscription;
    currency: string;

    constructor(private survivalHorizonService: SurvivalHorizonService,
        private dashboardEventService: DashboardEventService) { }

    ngOnInit() {
        setTimeout(() => {
            this.updateTableData(null);
        }, 500);
        this.subscription = (this.dashboardEventService.currencySelectionSubject.subscribe({
            next: currency => {
                this.currency = currency;
                const currentRequest = this.survivalHorizonService.buildPollingRequestParams();
                this.showTable = false;
                this.survivalHorizonService.getDataObservable(currentRequest)
                    .pipe(take(1))
                    .toPromise()
                    .then((data: GetSurvivalHorizonServiceDataOutput) => {
                        this.updateTableData(data);
                    })
            }
        }));
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    updateTableData(data: GetSurvivalHorizonServiceDataOutput) {
        this.showTable = false;
        this.tableData = [];
        if (!this.currency || this.currency === 'INR') {
            this.tableData.push({ entityName: 'Client 12', balance: -10000000, limit: 15000000 });
            this.tableData.push({ entityName: 'Client 13', balance: -13000000, limit: 20000000 });
            this.tableData.push({ entityName: 'Client 14', balance: -3000000, limit: 10000000 });
            this.tableData.push({ entityName: 'Client 15', balance: 0, limit: 30000000 });
            this.tableData.push({ entityName: 'Client 16', balance: -50000000, limit: 50000000 });
            this.tableData.push({ entityName: 'Client 17', balance: -2000000, limit: 7000000 });
            this.tableData.push({ entityName: 'Client 18', balance: -2300000, limit: 4000000 });
            this.tableData.push({ entityName: 'Client 19', balance: -60000000, limit: 60000000 });
            this.tableData.push({ entityName: 'Client 20', balance: -3500000, limit: 3500000 });
        }
        this.showTable = true;
    }
}
